import React from 'react';

type WidgetAppState = {
  width: number;
  height: number;
  isMobile: boolean;
};

const initialState: WidgetAppState = {
  height: 0,
  isMobile: false,
  width: 0,
};

const AppDimensionsContext = React.createContext<WidgetAppState>(
  initialState,
);

export default AppDimensionsContext;
